import React from "react";
import styled from "styled-components";

const StyledNavMenu = styled.div`
  width: 1rem;
  height: 14px;
  margin: 1.1rem 1rem;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
  & > span {
    background-color: ${(props) =>
      props.isOpen
        ? props.color === "black"
          ? props.theme.color.white
          : props.theme.color.white
        : props.color === "black"
        ? props.theme.color.darkGrey
        : props.theme.color.white};
  }
`;

const StyledNavBar = styled.span`
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  border-radius: 1px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
  &:nth-child(1) {
    top: ${(props) => (props.isOpen ? "calc(50% - 1px)" : 0)};
    width: ${(props) => (props.isOpen ? "0%" : "100%")};
    left: ${(props) => (props.isOpen ? "50%" : "0")};
  }
  &:nth-child(2) {
    top: calc(50% - 1px);
    -webkit-transform: rotate(${(props) => (props.isOpen ? "45" : 0)}deg);
    -moz-transform: rotate(${(props) => (props.isOpen ? "45" : 0)}deg);
    -o-transform: rotate(${(props) => (props.isOpen ? "45" : 0)}deg);
    transform: rotate(${(props) => (props.isOpen ? "45" : 0)}deg);
  }
  &:nth-child(3) {
    top: calc(50% - 1px);
    -webkit-transform: rotate(${(props) => (props.isOpen ? "-45" : 0)}deg);
    -moz-transform: rotate(${(props) => (props.isOpen ? "-45" : 0)}deg);
    -o-transform: rotate(${(props) => (props.isOpen ? "-45" : 0)}deg);
    transform: rotate(${(props) => (props.isOpen ? "-45" : 0)}deg);
  }
  &:nth-child(4) {
    bottom: ${(props) => (props.isOpen ? "calc(50% - 1px)" : 0)};
    width: ${(props) => (props.isOpen ? "0%" : "100%")};
    left: ${(props) => (props.isOpen ? "50%" : "0")};
  }
`;

const MenuIcon = ({ color, isOpen, ...props }) => {
  return (
    <StyledNavMenu color={color} isOpen={isOpen}>
      <StyledNavBar isOpen={isOpen} />
      <StyledNavBar isOpen={isOpen} />
      <StyledNavBar isOpen={isOpen} />
      <StyledNavBar isOpen={isOpen} />
    </StyledNavMenu>
  );
};

export default MenuIcon;
